import type {
  FilterFunc,
  FilterState,
  FilterType,
} from "@/components/controls/grid/columnfilters/ColumnFilters";
import { buildApplyFilter } from "@/components/controls/grid/columnfilters/ColumnFilters";
import { Instant } from "@js-joda/core";
import { tenantService } from "@/app/services/extensions/tenantServiceExtended";

function isInstant(toTest: any): toTest is Instant {
  return (toTest as Instant)?.epochSecond !== undefined;
}

export const dateTimeFilterTypes: FilterType[] = [
  {
    type: "filter_after",
    values: 1,
    applyFunc: (itemValue: any, formattedItemValue: any, filterValue: any) => {
      if (!filterValue) {
        return true;
      }

      return (
        isInstant(itemValue) && itemValue.isAfter(Instant.parse(filterValue))
      );
    },
  },
  {
    type: "filter_before",
    values: 1,
    applyFunc: (itemValue: any, formattedItemValue: any, filterValue: any) => {
      if (!filterValue) {
        return true;
      }

      return (
        isInstant(itemValue) && itemValue.isBefore(Instant.parse(filterValue))
      );
    },
  },
  {
    type: "filter_on_date",
    values: 1,
    applyFunc: (itemValue: any, formattedItemValue: any, filterValue: any) => {
      if (!filterValue) {
        return true;
      }

      const itemDate = tenantService.instantToDate(itemValue);
      const filterDate = tenantService.instantToDate(
        Instant.parse(filterValue)
      );

      return isInstant(itemValue) && itemDate.equals(filterDate);
    },
  },
];

export function buildApplyDateTimeFilter(state: FilterState): FilterFunc {
  return buildApplyFilter(state, dateTimeFilterTypes);
}
